import {
  Store,
  NOTIFICATION_TYPE,
  NOTIFICATION_CONTAINER,
  NOTIFICATION_INSERTION,
} from "react-notifications-component";

const GENERIC_TITLES = new Set([
  "error",
  "success",
  "success!",
  "warning",
  "info",
  "action succeeded",
]);

function notificationCopy(title: string, message: string) {
  let displayTitle = (title || "").trim();
  let displayMessage = (message || "").trim();
  if (
    displayMessage &&
    (GENERIC_TITLES.has(displayTitle.toLowerCase()) ||
      displayMessage.toLowerCase().startsWith(displayTitle.toLowerCase()))
  ) {
    displayTitle = "";
  }
  if (!displayMessage && displayTitle) {
    displayMessage = displayTitle;
    displayTitle = "";
  }
  return { title: displayTitle, message: displayMessage };
}

export function showSnackbar(
  type: NOTIFICATION_TYPE,
  title: string,
  message: string,
  duration?: number,
  options: {
    container?: NOTIFICATION_CONTAINER;
    insert?: NOTIFICATION_INSERTION;
    dismiss?: {
      duration?: number;
      click?: boolean;
      touch?: boolean;
      showIcon?: boolean;
    };
  } = {}
) {
  const copy = notificationCopy(title, message);
  Store.addNotification({
    title: copy.title,
    message: copy.message,
    type: type,
    insert: "top",
    container: "top-right",
    dismiss: {
      duration: duration ? duration : type == "success" ? 1500 : 3000,
      click: options.dismiss?.click,
      touch: options.dismiss?.touch,
      showIcon: options.dismiss?.showIcon,
    },
  });
}
